import type { ApplyReportTemplateRow } from "./applyReportTemplateRows";

export const filterApplyReportTemplateRows = ({
    rows,
    search,
}: {
    rows: ApplyReportTemplateRow[];
    search: string;
}): ApplyReportTemplateRow[] => {
    const query = search.trim().toLowerCase();
    if (!query) {
        return rows;
    }
    const matches = (row: ApplyReportTemplateRow) =>
        row.name.toLowerCase().includes(query);
    return rows.flatMap((client) => {
        if (matches(client)) {
            return [client];
        }
        const children = (client.children ?? []).filter(matches);
        return children.length > 0 ? [{ ...client, children }] : [];
    });
};
